var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89.9999,
    height: 89.9999,
    rx: 15,
    transform: "matrix(0.707107 0.707106 -0.707107 0.707106 64 0)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33.6396,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#DEFDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3334 59.0146C51.3334 58.6057 51.5002 58.2136 51.7971 57.9244C52.0941 57.6353 52.4968 57.4729 52.9167 57.4729H59.25C59.67 57.4729 60.0727 57.6353 60.3696 57.9244C60.6666 58.2136 60.8334 58.6057 60.8334 59.0146C60.8334 59.4234 60.6666 59.8156 60.3696 60.1047C60.0727 60.3938 59.67 60.5562 59.25 60.5562H52.9167C52.4968 60.5562 52.0941 60.3938 51.7971 60.1047C51.5002 59.8156 51.3334 59.4234 51.3334 59.0146Z",
    fill: "#16E9BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3333 49.7646C49.6536 49.7646 48.0427 50.4143 46.855 51.5708C45.6673 52.7273 45 54.2958 45 55.9313V71.348C45 72.9835 45.6673 74.552 46.855 75.7085C48.0427 76.8649 49.6536 77.5146 51.3333 77.5146H76.6667C78.3464 77.5146 79.9573 76.8649 81.145 75.7085C82.3327 74.552 83 72.9835 83 71.348V55.9313C83 54.2958 82.3327 52.7273 81.145 51.5708C79.9573 50.4143 78.3464 49.7646 76.6667 49.7646H51.3333ZM76.6667 52.848H51.3333C50.4935 52.848 49.688 53.1728 49.0942 53.7511C48.5003 54.3293 48.1667 55.1136 48.1667 55.9313V66.723H79.8333V55.9313C79.8333 55.1136 79.4997 54.3293 78.9058 53.7511C78.312 53.1728 77.5065 52.848 76.6667 52.848ZM79.8333 69.8063H48.1667V71.348C48.1667 72.1657 48.5003 72.95 49.0942 73.5282C49.688 74.1065 50.4935 74.4313 51.3333 74.4313H76.6667C77.5065 74.4313 78.312 74.1065 78.9058 73.5282C79.4997 72.95 79.8333 72.1657 79.8333 71.348V69.8063Z",
    fill: "#16E9BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9786 58.9286V58.05C74.9786 57.5063 74.7626 56.9849 74.3782 56.6004C73.9937 56.216 73.4723 56 72.9286 56C72.3849 56 71.8635 56.216 71.479 56.6004C71.0946 56.9849 70.8786 57.5063 70.8786 58.05V58.9286M75.2715 58.9286H70.5857C70.4304 58.9286 70.2814 58.9903 70.1716 59.1001C70.0617 59.21 70 59.359 70 59.5143V63.0286C70 63.184 70.0617 63.3329 70.1716 63.4428C70.2814 63.5526 70.4304 63.6143 70.5857 63.6143H75.2715C75.4268 63.6143 75.5758 63.5526 75.6856 63.4428C75.7955 63.3329 75.8572 63.184 75.8572 63.0286V59.5143C75.8572 59.359 75.7955 59.21 75.6856 59.1001C75.5758 58.9903 75.4268 58.9286 75.2715 58.9286Z",
    stroke: "#16E9BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9286 61.5642C73.0063 61.5642 73.0808 61.5334 73.1357 61.4785C73.1906 61.4235 73.2215 61.349 73.2215 61.2714C73.2215 61.1937 73.1906 61.1192 73.1357 61.0643C73.0808 61.0094 73.0063 60.9785 72.9286 60.9785C72.8509 60.9785 72.7764 61.0094 72.7215 61.0643C72.6666 61.1192 72.6357 61.1937 72.6357 61.2714C72.6357 61.349 72.6666 61.4235 72.7215 61.4785C72.7764 61.5334 72.8509 61.5642 72.9286 61.5642Z",
    stroke: "#16E9BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventCheckout);
export default __webpack_public_path__ + "static/media/canvas_event_checkout.f3b08c3d600473811fc19077dfa8aa2b.svg";
export { ForwardRef as ReactComponent };